import { VueEditor, Quill } from 'vue2-editor'

// Set icon for Custom Button
const icons = Quill.import('ui/icons')
icons.hr = '<i class="black--text material-icons">remove</i>'
icons.quotes = '<i class="black--text material-icons">format_quote</i>'
icons.customLink = '<i class="black--text material-icons">insert_link</i>'

// New Custom Button for <hr> and custom <link> html element
const InlineBlot = Quill.import('blots/inline')
const BlockEmbed = Quill.import('blots/block/embed')

// Import clipboard and Delta for overide Clipboard Class methods
const Clipboard = Quill.import('modules/clipboard')
const Delta = Quill.import('delta')

// Class for Custom Link Module for Quill.js
class customLink extends InlineBlot {
  static create (value) {
    const node = super.create(value)
    // Check if checkBox come True or false
    node.setAttribute('href', value.url)
    if (value.blank) {
      node.setAttribute('target', '_blank')
    }
    return node
  }

  static formats (node) {
    return {
      url: node.getAttribute('href') || '',
      blank: node.getAttribute('target') === '_blank',
    }
  }
}
customLink.blotName = 'customLink' // How we call the element
customLink.className = 'ql-link' // now you can use .ql-hr classname in your toolbar
customLink.tagName = 'a' // Tag that wil be generated

// Class HR for Custom Break Module for Quill.js
class Hr extends BlockEmbed {}
Hr.blotName = 'hr' // How we call the element
Hr.className = 'ql-hr' // now you can use .ql-hr classname in your toolbar
Hr.tagName = 'hr' // Tag that wil be generated

// Class Quotes for Custom Break Module for Quill.js

class Quotes extends InlineBlot {

  static create(paramValue) {
    let node = super.create();
    if (typeof(paramValue) === 'string') {
      node.innerHTML = paramValue;
    } else {
      node.className = 'ql-cursor'
    }
    return node;
  }
  static formats (node) {
    return node
  }

  static value(node) {
    return node.innerHTML;
  }
}

class RedQuotes extends Quotes {}
RedQuotes.blotName = 'redquotes'
RedQuotes.className = 'text-quote-red'
RedQuotes.tagName = 'span' // Tag that wil be generated

class BlackQuotes extends Quotes {}
BlackQuotes.blotName = 'blackquotes'
BlackQuotes.className = 'text-quote-black'
BlackQuotes.tagName = 'span' // Tag that wil be generated

// Class PlainClipboard for custom onPaste method and only copy in plain text
class PlainClipboard extends Clipboard {
  onPaste (e) {
    e.preventDefault()
    const range = this.quill.getSelection()
    const text = e.clipboardData.getData('text/plain')
    const delta = new Delta()
      .retain(range.index)
      .delete(range.length)
      .insert(text)
    const index = text.length + range.index
    const length = 0
    this.quill.updateContents(delta, 'silent')
    this.quill.setSelection(index, length, 'silent')
    this.quill.insertText(index + 1, ' ', '', true);
    this.quill.scrollIntoView()
  }
}

// Register the news Modules
Quill.register(Hr)
Quill.register(RedQuotes)
Quill.register(BlackQuotes)
Quill.register(customLink)
Quill.register('modules/clipboard', PlainClipboard)

export { VueEditor, Quill, Delta }
